import { ParseResult } from "papaparse";
import React, { Component } from "react";
import "./SupplierUserCsvModalUpload.scss";
import ICreateVendorCsvDTO from "../../../../../models/DTO/ICreateVendorCsvDTO";
import IErrorDTO from "../../../../../models/DTO/IErrorDTO";
import IOnProcessSupplierUsersCsvDTO from "../../../../../models/DTO/IOnProcessSupplierUsersCsvDTO";
import IProcessSupplierUsersCsvDTO from "../../../../../models/DTO/IProcessSupplierUsersCsvDTO";
import EndpointsEnum from "../../../../../models/EndpointsEnum";
import ISupplierModel from "../../../../../models/ISupplierModel";
import ISupplierUserCsvDataRow from "../../../../../models/ISupplierUserCsvDataRow";
import IUserUI from "../../../../../models/IUserUI";
import IVendorUploadDataRow from "../../../../../models/IVendorUploadDataRow";
import OwButton from "../../../../shared/OwButton/OwButton";
import OwCsvReader from "../../../../shared/OwCsvReader/OwCsvReader";
import OwLabel from "../../../../shared/OwLabel/OwLabel";
import OwTitle from "../../../../shared/OwTitle/OwTitle";
import { Socket } from "socket.io-client";

type Props = {
    closeModalFn: () => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
};

type State = {
    isProcessing: boolean;
    csvData: any;
    file: any;
    uploadActive: boolean;
    showResults: boolean;
    totalRecords: number;
    processedRows: number;
};

class SupplierUserCsvModalUpload extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            isProcessing: false,
            csvData: null,
            file: null,
            uploadActive: false,
            showResults: false,
            totalRecords: 0,
            processedRows: 0,
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.SuppliersOnProcessSupplierUsersCsv, this.onProcessSupplierUsersCsv);
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.SuppliersOnProcessSupplierUsersCsv, this.onProcessSupplierUsersCsv);
    }

    closeModal = () => {
        this.props.closeModalFn();
    };

    create = () => {};

    setupCSVData = (csvData: ParseResult<any>) => {
        const users: ISupplierUserCsvDataRow[] = [];

        // console.log('csvData', csvData);

        for (const row of csvData.data) {
            const data: ISupplierUserCsvDataRow = {
                email: row.email,
                access_type: row.access_type,
                user_type: row.user_type,
                commission_rate: row.commission_rate,
            };

            users.push(data);
        }

        const payload: IProcessSupplierUsersCsvDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            rows: JSON.stringify(users),
        };

        this.props.socket.emit(EndpointsEnum.SuppliersProcessSupplierUsersCsv, payload);

        this.setState({
            totalRecords: 0,
            processedRows: 0,
            showResults: false,
        });
    };

    onProcessSupplierUsersCsv = (data: IOnProcessSupplierUsersCsvDTO) => {
        this.setState({
            showResults: true,
            totalRecords: data.totalRecords,
            processedRows: data.recordsCreated,
        });
    };

    doUpload = () => {
        this.setState(
            {
                uploadActive: true,
            },
            () => {
                this.setupCSVData(this.state.csvData);
            }
        );
    };

    csvLoaded = (csvData?: ParseResult<any>) => {
        if (csvData) {
            this.setState({
                csvData,
            });
        }
    };

    render() {
        return (
            <div className={"SupplierUserCsvModalUpload p-2"}>
                <div className={"w-100"} style={{ minHeight: "2rem" }}>
                    <div className={"d-flex justify-content-between"}>
                        <OwTitle leftIconName={"fad fa-cloud-upload-alt"} title={"upload_users_csv"} tag={"h3"} />
                        <div>
                            <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={this.closeModal} />
                        </div>
                    </div>
                </div>

                <div>
                    {this.state.showResults ? null : (
                        <div className={""}>
                            <div className={""}>
                                <div className={"drop-area"}>
                                    <OwCsvReader onFileLoaded={this.csvLoaded} isProcessing={this.state.isProcessing} />
                                </div>
                            </div>

                            <div className={""}>
                                {this.state.file ? (
                                    <div>
                                        <OwLabel title={"loaded_file"} noBottomMargin={true} isBold={true} isUnderline={true} />:{" "}
                                        {this.state.file.name}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    )}

                    {this.state.showResults ? null : (
                        <div className={""}>
                            <div className={"mt-4"}>
                                <OwButton title={"upload"} fn={this.doUpload} active={this.state.uploadActive} disableOnActive={true} />
                            </div>
                        </div>
                    )}

                    {this.state.showResults ? (
                        <div className={"mt-2"}>
                            <div>
                                <OwLabel title={"total_records"} noBottomMargin={true} className={"me-3"} isBold={true} />
                                {this.state.totalRecords}
                            </div>

                            <div>
                                <OwLabel title={"records_updated"} noBottomMargin={true} className={"me-3"} isBold={true} />
                                {this.state.processedRows}
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }
}

export default SupplierUserCsvModalUpload;
